import React, { useState, useEffect } from 'react';
import './CadastroUsuario.css';

const CadastroUsuario = ({ onBack }) => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    operadorId: '',
    cargo: 'operador'
  });
  
  const [operadores, setOperadores] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loadingOperadores, setLoadingOperadores] = useState(true);

  // Carregar operadores ao montar o componente
  useEffect(() => {
    const loadOperadores = async () => {
      try {
        const response = await fetch('https://vega-solutions.site/api/operadores.php');
        const data = await response.json();
        
        if (response.ok && data.success) {
          setOperadores(data.operadores);
        }
      } catch (error) {
        console.error('Erro ao carregar operadores:', error);
        setErrors({ general: 'Erro ao carregar operações' });
      } finally {
        setLoadingOperadores(false);
      }
    };
    
    loadOperadores();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpar erro do campo quando usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nome.trim()) {
      newErrors.nome = 'Nome é obrigatório';
    } else if (formData.nome.length < 3) {
      newErrors.nome = 'Nome deve ter pelo menos 3 caracteres';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    
    if (!formData.senha.trim()) {
      newErrors.senha = 'Senha é obrigatória';
    } else if (formData.senha.length < 6) {
      newErrors.senha = 'Senha deve ter pelo menos 6 caracteres';
    }
    
    if (!formData.confirmarSenha.trim()) {
      newErrors.confirmarSenha = 'Confirmação de senha é obrigatória';
    } else if (formData.senha !== formData.confirmarSenha) {
      newErrors.confirmarSenha = 'Senhas não coincidem';
    }
    
    if (!formData.operadorId) {
      newErrors.operadorId = 'Selecione uma operação';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsLoading(true);
    setErrors({});
    
    try {
      const response = await fetch('https://vega-solutions.site/api/usuarios.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome: formData.nome,
          email: formData.email,
          senha: formData.senha,
          operador_id: formData.operadorId,
          cargo: formData.cargo
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        alert('Usuário criado com sucesso!');
        // Limpar formulário
        setFormData({
          nome: '',
          email: '',
          senha: '',
          confirmarSenha: '',
          operadorId: '',
          cargo: 'operador'
        });
      } else {
        setErrors({ 
          general: data.error || 'Erro ao criar usuário' 
        });
      }
    } catch (error) {
      setErrors({ 
        general: 'Erro ao conectar com o servidor. Verifique se está rodando.' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="cadastro-usuario-container">
      <div className="cadastro-header">
        <button className="back-button" onClick={onBack}>
          ← Voltar
        </button>
        <h2>Cadastrar Novo Usuário</h2>
      </div>

      <div className="cadastro-form-container">
        <form className="cadastro-form" onSubmit={handleSubmit}>
          {errors.general && (
            <div className="error-message error-general">
              <span className="error-icon">⚠️</span>
              {errors.general}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="nome" className="form-label">
              <span className="label-icon">👤</span>
              Nome Completo
            </label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={formData.nome}
              onChange={handleInputChange}
              className={`form-input ${errors.nome ? 'error' : ''}`}
              placeholder="Ex: João Silva"
              disabled={isLoading}
            />
            {errors.nome && (
              <span className="field-error">{errors.nome}</span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              <span className="label-icon">📧</span>
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className={`form-input ${errors.email ? 'error' : ''}`}
              placeholder="Ex: joao@empresa.com"
              disabled={isLoading}
            />
            {errors.email && (
              <span className="field-error">{errors.email}</span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="operadorId" className="form-label">
              <span className="label-icon">🏢</span>
              Operação
            </label>
            <select
              id="operadorId"
              name="operadorId"
              value={formData.operadorId}
              onChange={handleInputChange}
              className={`form-input ${errors.operadorId ? 'error' : ''}`}
              disabled={isLoading || loadingOperadores}
            >
              <option value="">Selecione uma operação</option>
              {operadores.map(operador => (
                <option key={operador.id} value={operador.id}>
                  {operador.nome} - {operador.asc_code}
                </option>
              ))}
            </select>
            {errors.operadorId && (
              <span className="field-error">{errors.operadorId}</span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="cargo" className="form-label">
              <span className="label-icon">🎭</span>
              Cargo
            </label>
            <select
              id="cargo"
              name="cargo"
              value={formData.cargo}
              onChange={handleInputChange}
              className="form-input"
              disabled={isLoading}
            >
              <option value="operador">Operador</option>
              <option value="administrador">Administrador</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="senha" className="form-label">
              <span className="label-icon">🔒</span>
              Senha
            </label>
            <input
              type="password"
              id="senha"
              name="senha"
              value={formData.senha}
              onChange={handleInputChange}
              className={`form-input ${errors.senha ? 'error' : ''}`}
              placeholder="Mínimo 6 caracteres"
              disabled={isLoading}
            />
            {errors.senha && (
              <span className="field-error">{errors.senha}</span>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmarSenha" className="form-label">
              <span className="label-icon">🔒</span>
              Confirmar Senha
            </label>
            <input
              type="password"
              id="confirmarSenha"
              name="confirmarSenha"
              value={formData.confirmarSenha}
              onChange={handleInputChange}
              className={`form-input ${errors.confirmarSenha ? 'error' : ''}`}
              placeholder="Digite a senha novamente"
              disabled={isLoading}
            />
            {errors.confirmarSenha && (
              <span className="field-error">{errors.confirmarSenha}</span>
            )}
          </div>
          
          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={onBack}
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={`submit-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="loading-spinner"></div>
                  Criando...
                </>
              ) : (
                <>
                  <span className="button-icon">✅</span>
                  Criar Usuário
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroUsuario;
